import { useState } from 'react';
import classes from 'classnames';
import InteractiveArea from 'ui/components/InteractiveArea';
import styles from './VersionInfo.module.scss';

const VERSION = '[VI]{version} - {date}[/VI]';

export default function VersionInfo() {
  const [toggle, setToggle] = useState<boolean>(false);

  const handleToggle = () => {
    setToggle((prev) => !prev);
  };

  return (
    <>
      {process.env.REACT_APP_ENV !== 'production' && (
        <InteractiveArea
          className={classes(
            styles.version,
            toggle ? styles.fixed : styles.hover,
          )}
          onClick={handleToggle}
        >
          <div className={styles.inner}>version: {VERSION}</div>
        </InteractiveArea>
      )}
    </>
  );
}
